import { r as registerInstance, e as createEvent, h } from './index-a67e306f.js';

function getExpiryDate() {
  const date = new Date();
  date.setTime(date.getTime() + (3 * 360 * 24 * 60 * 60 * 1000));
  return date;
}
const DEFAULT_COOKIE_OPTIONS = {
  expires: getExpiryDate(),
  path: '/'
};
/**
 * Helper function for setting a single cookie.
 *
 * @param {string} name The name of the cookie.
 * @param {string} value The value of the cookie.
 * @param {CookieOptions} options Optional cookie options
 *
 *
 * @example
 * import { setCookie } from './utils/setCookie';
 *
 * setCookie('test', 'test-value', {
 *  samesite: 'strict',
 *  secure: false
 * });
 *
 * console.log(document.cookies) // outputs the new cookies.
 */
function setCookie(name, value, options) {
  const opts = Object.assign(Object.assign({}, DEFAULT_COOKIE_OPTIONS), options);
  const cookieOptionsToString = Object.entries(opts)
    .map(([key, v]) => (`${key}=${(v instanceof Date) ? v.toUTCString() : v}`)).join('; ');
  const cookie = `${name}=${encodeURIComponent(value + '---' + Date.now())}; ${cookieOptionsToString};`;
  document.cookie = cookie;
}

/**
 * Fuction to get a cookie from the browser by name.
 *
 * @param {string} cookieName The name of the cookie.
 *
 * @returns {string[]|undefined} The cookie value or undefined
 *
 * @example
 * import { getCookie } from './utils';
 *
 * const cookie = getCookie('test');
 *
 * console.log(cookie); // outputs ["cookie value", "creation date"] or undefined
 */
function getCookie(cookieName) {
  const cookie = document.cookie
    .split('; ')
    .find(cookies => cookies.startsWith(`${cookieName}`));
  return (cookie ?
    cookie.split('=')[1].split('---') :
    []);
}

const cookieConsentBannerCss = "body{margin:0}.cookie-consent-banner{width:100%;background-color:#f2f2f2;box-shadow:0 0 15px 1px rgba(0, 0, 0, 0.15)}.cookie-consent-banner.showing{opacity:1;z-index:2000;visibility:visible;display:flex;height:auto;max-width:100vw}.cookie-consent-banner.showing:focus{outline:none}.cookie-consent-banner.showing.leaving{animation:ease-in-out-slide-down 0.5s ease-in-out;-webkit-animation:ease-in-out-slide-down 0.5s ease-in-out;-moz-animation:ease-in-out-slide-down 0.5s ease-in-out}.cookie-consent-banner.hidden{display:none}.cookie-consent-banner__position--fixed-bottom{bottom:0;position:fixed}.cookie-consent-banner__position--fixed-top{top:0;position:fixed}.cookie-consent-banner__position--absolute-bottom{bottom:0;position:absolute}.cookie-consent-banner__position--absolute-top{top:0;position:absolute}.cookie-consent-banner__position--sticky-bottom{bottom:0;position:-webkit-sticky;position:sticky}.cookie-consent-banner__position--sticky-top{top:0;position:-webkit-sticky;position:sticky}.cookie-consent-banner__position--relative{position:relative}.cookie-consent-banner__title{margin-block:0;color:#c7202f;font-family:\"Gotham SSm A\", \"Gotham SSm B\", arial, sans-serif;font-size:calc(1.29375rem + 0.525vw)}@media (min-width: 1200px){.cookie-consent-banner__title{font-size:1.6875rem}}.cookie-consent-banner__title:focus{outline:none}@media screen and (max-width: 640px){.cookie-consent-banner__title{font-size:1.25rem}}.cookie-consent-banner__text{margin-block:0;line-height:1.5;color:#282828;font-family:\"Gotham SSm A\", \"Gotham SSm B\", arial, sans-serif;font-weight:400;font-size:0.6875rem}.cookie-consent-banner__text:focus{outline:none}.consent-body{display:flex;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;padding:calc(1.33125rem + 0.975vw) calc(1.36875rem + 1.425vw)}@media (min-width: 1200px){.consent-body{padding:2.0625rem 2.4375rem}}@media screen and (max-width: 1280px){.consent-body{flex-wrap:wrap}}@media screen and (max-width: 640px){.consent-body{padding:calc(1.3rem + 0.6vw) 0.9375rem}}@media screen and (max-width: 640px) and (min-width: 1200px){.consent-body{padding:1.75rem 0.9375rem}}.banner-title{display:inline-flex;height:-webkit-fit-content;height:-moz-fit-content;height:fit-content;align-self:center}@media screen and (max-width: 1280px){.banner-title{display:inline-block;height:revert;align-self:revert}}.banner-title span:last-child{display:flex;align-items:flex-end}@media screen and (min-width: 1281px){.banner-title span:last-child{padding-left:8px;padding-bottom:9px}}@media screen and (max-width: 1280px){.banner-title span:last-child{display:block}}.banner-title span:last-child .line{height:2px;background-color:#c7202f;width:25px}@media screen and (max-width: 1280px){.banner-title span:last-child .line{margin:0.9375rem 0}}.banner-text{padding-left:0;padding-right:0}@media screen and (min-width: 1440px){.banner-text{padding-right:44px;padding-left:44px}}@media screen and (max-width: 1440px) and (min-width: 1281px){.banner-text{padding-right:44px;padding-left:44px}}@media screen and (max-width: 1280px){.banner-text{padding-bottom:23px}}@media screen and (max-width: 640px){.banner-text{font-size:0.5rem}}.btn-group{display:grid;width:-webkit-fit-content;width:-moz-fit-content;width:fit-content;grid-template-areas:\"accept deny\";grid-template-columns:auto auto;grid-gap:44px}@media screen and (min-width: 1281px){.btn-group{grid-template-areas:\"deny accept\";grid-template-columns:auto auto}}@media screen and (max-width: 290px){.btn-group{width:100%;grid-gap:15px}}@media screen and (max-width: 400px){.btn-group{width:100%;grid-gap:5px}}.btn-group :first-child{grid-area:accept}.btn-group :last-child{grid-area:deny}@keyframes ease-in-out-slide-down{0%{transform:translateY(0)}100%{transform:translateY(100%)}}@-webkit-keyframes ease-in-out-slide-down{0%{transform:translateY(0)}100%{transform:translateY(100%)}}";

const CookieConsentBanner = class {
  constructor(hostRef) {
    registerInstance(this, hostRef);
    this.consented = createEvent(this, "consented", 7);
    this.isShowing = true;
    this.leaving = false;
    /**
     * What text you want to appear on the banner
     */
    this.cookieBannerText = 'We use cookies to improve and personalise your experience so that you don’t have to. By clicking “Allow all cookies”, you agree to the storing of cookies on your device to enhance site navigation, analyze site usage, and assist in our marketing efforts.';
    /**
     * What title you want to use for the banner
     */
    this.cookieBannerTitle = 'Cookies';
    /**
     * The text for the accept button
     */
    this.acceptButtonText = "accept all cookies";
    /**
     * The text for the deny button
     */
    this.denyButtonText = "decline all cookies";
    /**
     * Custom classes for the container element
     */
    this.containerClasses = {};
    /**
     * The name you want to give the consent cookie.
     * ** Note this should be unique **
     */
    this.consentCookieName = '__cookieconsent';
    /**
     * The value you want to use to identify a user accepting cookies
     */
    this.consentCookieAcceptValue = "accepted";
    /**
     * The value you want to use to identify a user declining cookies
     */
    this.consentCookieDeniedValue = "declined";
    /**
     * A object that allows you to set custom html classes for the
     * accept and deny button
     */
    this.buttonClasses = { accept: {}, deny: {} };
    this.position = ['fixed', 'bottom'];
    this.ref = null;
  }
  handleButtonPress(event) {
    this.leaving = true;
    if (event.detail.type === 'accept') {
      setCookie(this.consentCookieName, this.consentCookieAcceptValue);
    }
    else {
      setCookie(this.consentCookieName, this.consentCookieDeniedValue);
    }
    this.emitConsentData();
    if (this.ref) {
      this.ref.addEventListener('animationend', () => {
        this.isShowing = false;
        this.leaving = false;
      });
    }
  }
  componentWillLoad() {
    this.emitConsentData();
  }
  componentDidLoad() {
    if (this.ref && this.styles) {
      Object.entries(this.styles).forEach(([key, value]) => {
        this.ref.style[key] = value;
      });
    }
  }
  emitConsentData() {
    const [status, consentedOn] = getCookie(this.consentCookieName);
    if (status) {
      const created = new Date(Number(consentedOn)).toUTCString();
      if (!this.leaving) {
        this.isShowing = false;
      }
      this.consented.emit({
        status,
        created
      });
    }
  }
  render() {
    const { cookieBannerTitle, cookieBannerText, acceptButtonText, denyButtonText, containerClasses, buttonClasses, position, leaving } = this;
    const showing = this.isShowing;
    const baseClassName = 'cookie-consent-banner';
    const _position = position ?
      `${baseClassName}__position--${position[0]}-${position[1]}` :
      false;
    return (h("div", { ref: el => this.ref = el, class: Object.assign({ [baseClassName]: true, [`${_position}`]: typeof _position === 'string', showing, hidden: !showing && !leaving, leaving }, containerClasses), tabindex: "-1", role: "dialog", "aria-labelledby": "dialog-title", "aria-describedby": "dialog-text", "aria-hidden": !showing ? "true" : "false" }, h("div", { class: { 'consent-body': true } }, h("div", { class: { [`banner-title`]: true } }, h("span", null, h("h1", { id: "dialog-title", class: {
        [`${baseClassName}__title`]: true
      } }, cookieBannerTitle)), h("span", null, h("div", { "aria-hidden": "true", class: { line: true } }))), h("p", { id: "dialog-text", class: {
        'banner-text': true,
        [`${baseClassName}__text`]: true
      } }, cookieBannerText), h("div", { class: { 'btn-group': true } }, h("cookie-button", { type: "accept", classes: buttonClasses.accept, onPress: ev => this.handleButtonPress(ev) }, acceptButtonText), h("cookie-button", { type: "deny", classes: buttonClasses.deny, onPress: ev => this.handleButtonPress(ev) }, denyButtonText)))));
  }
};
CookieConsentBanner.style = cookieConsentBannerCss;

export { CookieConsentBanner as cookie_consent_banner };
